import { store } from '../store/store';
import { HttpRequest } from '../utils';

const httpRequest = new HttpRequest(store);

export const list = async (data: { page: number; limit: number; query?: string }) => {
  const res = await httpRequest.get('/api/car_model', data);
  return res;
};

export const create = async ({
  carBrandId,
  name,
  source,
  sourceUrl,
  score,
}: {
  carBrandId: string | undefined;
  name: string | undefined;
  source: string | undefined;
  sourceUrl: string | undefined;
  score: number | undefined;
}) => {
  const res = await httpRequest.post('/api/car_model', {
    carBrandId,
    name,
    source,
    sourceUrl,
    score,
  });
  return res;
};

export const get = async (id: string) => {
  const res = await httpRequest.get(`/api/car_model/${id}/detail`);
  return res;
};

export const select = async (payload: any) => {
  const res = await httpRequest.get(`/api/car_model/select`, {
    ...payload,
    limit: 100,
  });
  return res;
};

export const remove = async (id: string) => {
  const res = await httpRequest.del(`/api/car_model/${id}`);
  return res;
};

export const update = async ({
  id,
  carBrandId,
  name,
  source,
  sourceUrl,
  score,
}: {
  id: string;
  carBrandId: string | undefined;
  name: string | undefined;
  source: string | undefined;
  sourceUrl: string | undefined;
  score: number | undefined;
}) => {
  const res = await httpRequest.put(`/api/car_model/${id}/update`, {
    carBrandId,
    name,
    source,
    sourceUrl,
    score,
  });
  return res;
};
